import { formatMultilineAddress } from '../../multiline-address';
export function formatBookingsAddress(submission, t, language) {
  return formatMultilineAddress(submission, t, language);
}
//# sourceMappingURL=bookings-address-preview.js.map